import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';
import Star from 'components/ui/icon/Star';
import ArrowAnchor from 'components/ui/icon/ArrowAnchor';
import pluralize from 'utils/pluralize';

import './ExternalReviews.scss';

const ExternalReviews = () => {
  return (
    <section className="external-reviews">
      <Container extraClassName="external-reviews__wrapper">
        <Title
          extraClassName="external-reviews__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          627 713 клиентов
        </Title>

        <p className="external-reviews__subscript">
          уже воспользовались сервисом Руки
        </p>

        <div className="external-reviews__items_wrapper">
          <div className="external-reviews__items">
            {[
              {
                score: 4.9,
                count: 979,
                link: 'https://yandex.ru/maps/org/ruki/6873543134/reviews/?ll=37.522261%2C55.797300&z=14',
                anchor: 'Яндекс',
              },
              {
                score: 4.5,
                count: 422,
                link: 'https://play.google.com/store/apps/details?id=ru.hands.clientapp&hl=ru&gl=US&pli=1',
                anchor: 'Google play',
              },
              {
                score: 4.3,
                count: 2700,
                link: 'https://apps.apple.com/ru/app/%D1%80%D1%83%D0%BA%D0%B8-%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81-%D1%80%D0%B5%D0%BC%D0%BE%D0%BD%D1%82%D0%B0/id1350343402',
                anchor: 'AppStore',
              },
              {
                score: 4.5,
                count: 232,
                link: 'https://yandex.ru/maps/org/ruki/6873543134/reviews/?ll=37.522261%2C55.797300&z=14',
                anchor: '2GIS',
              },
            ].map((externalReview, index) => (
              <div
                className="external-reviews__item"
                key={externalReview.anchor}
              >
                <div
                  className={`external-reviews__item-score external-reviews__item-score_${
                    index + 1
                  }`}
                >
                  <Star extraClassName="external-reviews__item-score-icon" />{' '}
                  {externalReview.score}
                </div>

                <div className="external-reviews__item_bottom">
                  <p className="external-reviews__item-count">
                    {externalReview.count}{' '}
                    {pluralize(
                      externalReview.count,
                      'отзыв',
                      'отзыва',
                      'отзывов',
                    )}
                  </p>

                  <a
                    className="external-reviews__item-anchor"
                    href={externalReview.link}
                  >
                    {externalReview.anchor} <ArrowAnchor />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="external-reviews__info">
          {[
            {
              title: <>6&nbsp;лет</>,
              description: <>развиваем сервис домашнего ремонта</>,
            },
            {
              title: <>80&nbsp;113 ремонтов</>,
              description: <>выполнили за&nbsp;год в&nbsp;Москве</>,
            },
            {
              title: <>8&nbsp;лет</>,
              description: <>средний опыт работы мастеров в&nbsp;бригадах</>,
            },
            {
              title: <>12&nbsp;дней</>,
              description: (
                <>в&nbsp;среднем проходит от&nbsp;заявки до&nbsp;начала работ</>
              ),
            },
          ].map((item, index) => (
            <div key={index} className="external-reviews__info-item">
              <p className="external-reviews__info-item-title">{item.title}</p>

              <p className="external-reviews__info-item-description">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ExternalReviews;
